import { toaster } from "rsuite";
import peticionBack from "../../libs/peticiones/peticionBack";
import { useState } from "react";
import CardC from "../../components/CustomCard/CardC";
import Datatable from "../../components/Datatable/Datatable";
import createURL from "../../libs/peticiones/url";
import { Usuario } from "../../types/admin-usuarios/Usuario";
import { fDatetime } from "../../libs/formats";
import InputForm from "../../components/inputs/InputForm";
import Alert from "../../components/notification/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Row } from "react-bootstrap";

export default function Bitacora() {
  const [refresh, setRefresh] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<any>("");
  const [endDate, setEndDate] = useState<any>("");

  async function getData(order: string, records: number, page: number) {
    const url = createURL("/bitacora", [
      { name: "populate", value: "user" },
      { name: "order", value: order },
      { name: "records", value: records },
      { name: "page", value: page },
      { name: "startDate", value: startDate ? (startDate+'T00:00:00Z') : "2000-01-01T00:00:00Z" },
      { name: "endDate", value: endDate ? (endDate+'T23:59:59Z') : "2099-01-01T00:00:00Z" },
    ]);
    const res = await peticionBack({}, url, "GET", false, toaster);
    if (startDate < endDate) {
      return res;
    } else if (startDate && endDate) {
      toaster.push(
        Alert({
          type: "warning",
          message: "La fecha de inicio debe ser menor que la fecha final",
        }),
        {
          placement: "topEnd",
        }
      );
      return res;
    }
    return res;
  }
  /* TABLA */
  const columns = [
    {
      data: "user",
      render: (data: Usuario) => data.fullname,
      orderValue: "user.fullname",
    },
    {
      data: "createdAt",
      render: (data: string) => fDatetime(data),
      orderValue: "createdAt",
    },
    { data: "result", orderValue: "result" },
    { data: "message", orderValue: "message" },
  ];
  const headers = ["Usuario", "Fecha", "Resultado", "Mensaje"];
  const columnsDef = [{ className: "text-center", targets: [0, 1, 2, 3] }];

  return (
    <>
      <CardC>
        <>
          <h4 className="pb-4">Bítacora de movimientos</h4>
        </>
        <DateRangeFilter
          setRefresh={setRefresh}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />

        <Datatable
          columns={columns}
          columnDefs={columnsDef}
          headers={headers}
          control="back"
          petition={getData}
          stateRefresh={[refresh, setRefresh]}
          searching={false}
        />
      </CardC>
    </>
  );
}

function DateRangeFilter({
  setRefresh,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}: {
  setRefresh: any;
  startDate: string;
  endDate: string;
  setStartDate: any;
  setEndDate: any;
}) {
  const handleStartDateChange = (e: any) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e: any) => {
    setEndDate(e.target.value);
  };

  const handleFilter = () => {
    setRefresh(true);
  };

  return (
    <>
      <Row>
        <Col xs={12} md={5}>
          <InputForm
            label="Fecha de inicio"
            name="fechaI"
            type="date"
            value={startDate}
            onChangeMethod={handleStartDateChange}
          />
        </Col>
        <Col xs={12} md={5}>
          <InputForm
            label="Fecha de fin"
            name="FechaF"
            type="date"
            value={endDate}
            onChangeMethod={handleEndDateChange}
          />
        </Col>
        <Col xs={12} md={2} className="align-self-center pt-md-2 d-grid d-md-block">
          <Button onClick={handleFilter} variant="info">
            Filtrar
            <FontAwesomeIcon className="ms-2" icon={faFilter}/>
          </Button>
        </Col>
      </Row>
    </>
  );
}
